import React from "react";
import { Box, Tab, Tabs } from "@mui/material";
import Texts from "./Texts";
import Contacts from "./Contacts";
import Pdfs from "./Pdfs";
import Image from "./Image";
import Audio from "./Audio";
function AccGrpBtn() {
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const sel = {
    m: 0.3,
    "&.Mui-selected": {
      backgroundColor: "#1D4353",
      color: "white",
    },
    color: "black",
    backgroundColor: "white",
  };

  function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ textAlign: "-webkit-center" }}>{children}</Box>
        )}
      </div>
    );
  }

  return (
    <Box className="Group1">
      <Tabs
        scrollButtons={false}
        className="tabs"
        value={value}
        onChange={handleChange}
        aria-label="nav tabs example"
        orientation="vertical"
      >
        <Tab className="Accs" sx={sel} label="Text"></Tab>
        <Tab className="Accs" sx={sel} label="Contact"></Tab>
        <Tab className="Accs" sx={sel} label="Pdf"></Tab>
        <Tab className="Accs" sx={sel} label="Image"></Tab>
        <Tab className="Accs" sx={sel} label="Audio"></Tab>
      </Tabs>
      <TabPanel className="Tabspanel" value={value} index={0}>
        <Texts />
      </TabPanel>
      <TabPanel className="Tabspanel" value={value} index={1}>
        <Contacts />
      </TabPanel>
      <TabPanel className="Tabspanel" value={value} index={2}>
        <Pdfs />
      </TabPanel>
      <TabPanel className="Tabspanel" value={value} index={3}>
        <Image />
      </TabPanel>
      <TabPanel className="Tabspanel" value={value} index={4}>
        <Audio />
      </TabPanel>
    </Box>
  );
}

export default AccGrpBtn;
